import {ToggleGroup} from "omni-toggle";

(function () {
  if (document.querySelector('.login-bar')) {
    new ToggleGroup(document.querySelector('.login-bar'), {
      items: '.login-bar__user, .login-bar__participant',
      button: '.login-bar__button',
      content: '.login-bar__content',
      closeOnBlur: true,
      afterToggle: e => {
        const firstInput = e.target?.querySelector('input') ?? null;
        if (e.detail.active && firstInput) {
          firstInput.focus();
        }
      }
    });
  }
})();